/*
 * @Author: Yu JiaZe
 * @Description:
 * @Date: 2020-01-03 15:08:20
 * @LastEditTime: 2021-04-08 20:55:52
 */

import { Freeer } from '.';
import { SandBox, SandboxRecordStatus } from '../sandbox';

const win: Window = window;

const originAddEventListener = win.addEventListener;
const originRemoveEventListener = win.removeEventListener;

interface HijackedListener {
    recordStatus: SandboxRecordStatus;
    listener: EventListenerOrEventListenerObject;
    options?: boolean | AddEventListenerOptions;
}

export const createEventListenerSandbox: Freeer = (sandbox: SandBox) => {
    const listenerMap = new Map<string, HijackedListener[]>();

    const listenerShouldRecover: {
        type: string;
        listener: EventListenerOrEventListenerObject;
        options?: boolean | AddEventListenerOptions;
    }[] = [];

    win.addEventListener = (
        type: string,
        listener: EventListenerOrEventListenerObject,
        options?: boolean | AddEventListenerOptions
    ) => {
        const listeners = listenerMap.get(type) || [];
        listenerMap.set(type, [
            ...listeners,
            { listener, recordStatus: sandbox.recordStatus, options },
        ]);
        return originAddEventListener.call(win, type, listener, options);
    };

    win.removeEventListener = (
        type: string,
        listener: EventListenerOrEventListenerObject,
        options?: boolean | AddEventListenerOptions
    ) => {
        const storedTypeListeners = listenerMap.get(type);
        if (
            storedTypeListeners &&
            storedTypeListeners.length &&
            storedTypeListeners.find((l) => l.listener === listener)
        ) {
            storedTypeListeners.splice(
                storedTypeListeners.findIndex((l) => l.listener === listener),
                1
            );
        }
        return originRemoveEventListener.call(win, type, listener, options);
    };

    return {
        free() {
            listenerMap.forEach((listeners, type) =>
                [...listeners].forEach((hl) => {
                    win.removeEventListener(type, hl.listener);
                    if (hl.recordStatus === SandboxRecordStatus.BOOTSTRAP) {
                        listenerShouldRecover.push({
                            type,
                            listener: hl.listener,
                            options: hl.options,
                        });
                    }
                })
            );
            win.addEventListener = originAddEventListener;
            win.removeEventListener = originRemoveEventListener;

            return () => {
                if (listenerShouldRecover.length) {
                    listenerShouldRecover.forEach((l) => {
                        win.addEventListener(l.type, l.listener, l.options);
                    });
                }
            };
        },
    };
};
